import React from 'react';

import PropTypes from 'prop-types';
import queryString from 'query-string';
import { connect } from 'react-redux';
import {
    Redirect as RouterRedirect,
    withRouter,
} from 'react-router';

import { selectLocale } from 'wanderu-i18n';
import {
    buildAbsoluteUrl,
} from 'wanderu-utils';

function Redirect(props) {
    const {
        href = '',
        locale,
        location,
        mergeQueries = true,
        push = false,
        queries = {},
    } = props;

    function parseQueryString(qs) {
        if (typeof qs === 'object') {
            return qs;
        }

        return queryString.parse(qs);
    }

    const oldQueries = parseQueryString(location.search);
    let newQueries = parseQueryString(queries);

    if (mergeQueries) {
        newQueries = {
            ...oldQueries,
            ...newQueries,
        };
    }

    const removeLocale = href === '/' && locale === 'en-us';

    const url = buildAbsoluteUrl({
        allowCrossDomainProtocolRelative: false,
        href,
        language: removeLocale
            ? undefined
            : locale,
        queries: newQueries,
    });

    return (
        <RouterRedirect
            push={push}
            to={url}
        />
    );
}

const queriesShape = PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
]);

Redirect.propTypes = {
    href: PropTypes.string,
    mergeQueries: PropTypes.bool,
    push: PropTypes.bool,
    queries: queriesShape,
};

function mapStateToProps(state, ownProps) {
    return {
        locale: ownProps.locale || selectLocale(state),
    };
}

const RedirectWithRouter = withRouter(Redirect);

RedirectWithRouter.propTypes = Redirect.propTypes;

export {
    Redirect,
    mapStateToProps,
    queriesShape,
};

export default connect(mapStateToProps)(RedirectWithRouter);
